import { computed } from "vue";
import { useAuthStore } from "~/stores/auth";

/** Individual UI rollout; backend history and payment capabilities stay authoritative. */
export function useIndividualReceivingAccess() {
  const auth = useAuthStore();
  return computed(
    () =>
      auth.profileLoaded &&
      auth.user.permissions.isTeacher &&
      !auth.user.activeOrganization &&
      auth.user.featureFlags?.finance_receiving === true,
  );
}
